module.exports = __webpack_public_path__ + "static/media/loading.faf7c2a0.gif";